<div *ngIf="visibleSuggest" class="suggest-add-card" [class.mobile]="deviceService.isMobile()">
  <div class="info">
    <span class="text">{{ 'suggest-add-card.text' | translate }}</span>
    <on-ui-button class="poutline"
                  label="suggest-add-card.action"
                  (onclick)="openNewCardForm()">
    </on-ui-button>
  </div>
  <div class="close-action" (click)="onToggleAlert()">
    <app-icon [width]="20" [height]="20" icon="close-sidebar"></app-icon>
  </div>
</div>

<app-alert *ngIf="openAlert" type="info">
  <ng-container alert-title>{{ 'collections-constructor.texts.teacher-need-card-link' | translate }}</ng-container>
  <ng-container alert-body>{{ 'collections-constructor.texts.teacher-need-card' | translate }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="poutline"
                  label="collections-constructor.incomplete-alert.later"
                  (onclick)="closeSuggest()">
    </on-ui-button>
    <on-ui-button class="primary"
                  label="collections-constructor.texts.teacher-need-card-btn"
                  (onclick)="openNewCardForm()">
    </on-ui-button>
  </ng-container>
</app-alert>
